import React, { useState } from 'react'
import { Button, IconButton } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import AnahiDialog from './AnahiDialog'

interface EditButtonDialogProps {
  title: string 
  onAccept: () => void
  onDismiss?: () => void
  maxWidth?: any
  disabled?: boolean
  icon?: React.ReactNode
}

const EditButtonDialog: React.FC<EditButtonDialogProps> = ({ title, onAccept, onDismiss = () => {}, disabled, children, icon, maxWidth }) => {
  const [open, setOpen] = useState<boolean>(false)

  const handleOpen = () => { setOpen(true) }

  const handleDismiss = () => {
    onDismiss()
    setOpen(false)
  }

  const handleAccept = () => { 
    onAccept()
    setOpen(false)
  }

  return (<>
    <IconButton aria-label="edit" size="small" onClick={handleOpen}>
      {icon ? icon : <EditIcon fontSize="small" /> }
    </IconButton>

    <AnahiDialog
      open={open}
      maxWidth={maxWidth}
      title={title}
      onClose={handleDismiss}
      onSubmit={handleAccept}
      body={children}
      actions={<>
        <Button color="primary" type="submit" disabled={disabled}>
          Aceptar
        </Button>
        <Button color="secondary" onClick={handleDismiss}>
          Cancelar
        </Button>
      </>}
    />
  </>)
}

export default EditButtonDialog